import useTranslator from "../../hooks/useTranslator";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { Button, Card, Icon } from "../design";
import styles from "./NoteForLandlord.module.css";

const NoteForLandlord = ({
  note,
  onEditNote,
  disabled = false,
  processing = false,
  readOnly = false,
}) => {
  const { _t } = useTranslator();
  const tooltipText = processing
    ? _t(
        "profileProcessingWait",
        "Your profile is still being processed. Please wait until it's ready."
      )
    : disabled
      ? _t(
          "profileOutdatedRenewFirst",
          "Your profile is outdated. Please renew your profile first."
        )
      : undefined;

  // Small "Edit" button in the card header; when disabled it shows why.
  const editButton =
    onEditNote && !readOnly ? (
      disabled ? (
        <div data-tooltip-id="nfl-edit-tooltip">
          <Button
            variant="secondary"
            size="sm"
            iconStart={<Icon name="edit" />}
            onClick={onEditNote}
            disabled={disabled}
          >
            {_t("edit", "Edit")}
          </Button>
          <ReactTooltip
            id="nfl-edit-tooltip"
            place="top"
            className="react-tooltip-styling"
            render={() => <p>{tooltipText}</p>}
          />
        </div>
      ) : (
        <Button
          variant="secondary"
          size="sm"
          iconStart={<Icon name="edit" />}
          onClick={onEditNote}
        >
          {_t("edit", "Edit")}
        </Button>
      )
    ) : null;

  return (
    <Card
      className="tenant-profile-placeholder-card tenant-profile-placeholder-card--landlord-note"
      title={_t("noteForLandlord", "Note for landlord")}
      description={_t(
        "noteForLandlordPlaceholder",
        "Doesn't affect your completeness, but landlords read it."
      )}
      actions={editButton}
    >
      <div className={styles.noteWrap}>
        <p className={`${styles.note} ${!note ? styles.empty : ""}`}>
          {note || _t("noInformation", "No information")}
        </p>
      </div>
    </Card>
  );
};

export default NoteForLandlord;
